import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'filter>delete'
	},

	gql: {
		schema: gql`
			mutation AuctionFilterDelete(
				$real_estate_filter_id: ID
			) {
				request(
					real_estate_filter_id: $real_estate_filter_id
				) {
					status
				}
			}
		`
	}
};

export default request;
